/**
 * Мобильный портретный layout 1:1: видео собеседника на весь экран,
 * панель управления лежит поверх видео. Подписи (имя, логотип) поднимаются над панелью.
 */
export const MOBILE_SOLO_OVERLAY_BOTTOM_CLASS = 'bottom-[calc(96px+env(safe-area-inset-bottom,0px))]';
